// Centraliza IDs de status, métodos de entrega e tipos de pagamento usados no fluxo de Pedidos.
// Substitui as magic strings que estavam espalhadas em PedidosPage.js, utils/functions.js e nos cards.

export const STATUS_IDS = {
  PENDENTE_PAGAMENTO: '60774fa684e6861cb41a472f',
  CANCELADO: '6143439585ee0369a5dfacbc',
  PEDIDO_FEITO: '60774f9c84e6861cb41a472e',
  ACEITO: '6143412285ee0369a5dfacb4',
  PAG_APROVADO: '60774fb684e6861cb41a4730',
  EXPEDICAO: '6143414c85ee0369a5dfacb5',
  RETIRADA_DISPONIVEL: '6143434b85ee0369a5dfacba',
  COLETA: '614342eb85ee0369a5dfacb8',
  BACKOFFICE: '630d0625d8c7d3d0ea112058',
  EM_TRANSITO: '6143432885ee0369a5dfacb9',
  FINALIZADO: '6143436085ee0369a5dfacbb',
};

export const SHIPPING_METHOD_IDS = {
  CORREIOS_PAC: '61532d990d253dd8a450bcde',
  CORREIOS_SEDEX: '615602fdeaf72f4fe7f5ee24',
  PATRUS: '61560313eaf72f4fe7f5ee25',
  RETIRADA_EM_LOJA: '6156031beaf72f4fe7f5ee26',
  ENTREGA_KATUXA: '61560325eaf72f4fe7f5ee27',
};

export const STATUS_LABELS = {
  [STATUS_IDS.PENDENTE_PAGAMENTO]: 'Pendente Pagamento',
  [STATUS_IDS.CANCELADO]: 'Cancelado',
  [STATUS_IDS.PEDIDO_FEITO]: 'Pedido Feito',
  [STATUS_IDS.ACEITO]: 'Aceito',
  [STATUS_IDS.PAG_APROVADO]: 'Pag. Aprovado',
  [STATUS_IDS.EXPEDICAO]: 'Expedição',
  [STATUS_IDS.RETIRADA_DISPONIVEL]: 'Retirada Disponível',
  [STATUS_IDS.COLETA]: 'Coleta',
  [STATUS_IDS.BACKOFFICE]: 'Backoffice',
  [STATUS_IDS.EM_TRANSITO]: 'Em trânsito',
  [STATUS_IDS.FINALIZADO]: 'Finalizado',
  resEditarCliente: 'Backoffice',
};

export const SHIPPING_METHOD_LABELS = {
  [SHIPPING_METHOD_IDS.CORREIOS_PAC]: 'Correios - Pac',
  [SHIPPING_METHOD_IDS.CORREIOS_SEDEX]: 'Correios - Sedex',
  [SHIPPING_METHOD_IDS.PATRUS]: 'Patrus',
  [SHIPPING_METHOD_IDS.RETIRADA_EM_LOJA]: 'Retirada em Loja',
  [SHIPPING_METHOD_IDS.ENTREGA_KATUXA]: 'Entrega Katuxa',
};

export const PAYMENT_TYPE_LABELS = {
  credit: 'Cartão Crédito',
  debit: 'Cartão Débito',
  boleto: 'Boleto Bancário',
  pix: 'Pix',
};

export const getStatusLabel = (id) => STATUS_LABELS[id] ?? '—';
export const getShippingMethodLabel = (id) => SHIPPING_METHOD_LABELS[id] ?? '—';
export const getPaymentTypeLabel = (type) => PAYMENT_TYPE_LABELS[type] ?? '—';

export const getBandeiraGateway = (paymentType, gateway) => {
  const gatewayName = gateway === 'pagarme' ? 'Pagar Me' : 'Zoop';
  if (paymentType === 'credit') return `${gatewayName} Crédito`;
  if (paymentType === 'debit') return `${gatewayName} Débito`;
  if (paymentType === 'boleto') return 'Boleto';
  if (paymentType === 'pix') return `${gatewayName} Pix`;
  return '—';
};

// Código da filial matriz que enxerga as colunas Backoffice/Enviado.
export const MATRIZ_FILIAL_CODE = '000122';

// Faixa de CEP usada para roteamento especial: pedidos dentro dela vão para Backoffice;
// fora dela, são marcados como Finalizado direto.
export const DIVINOPOLIS_CEP_RANGE = { min: 35500000, max: 35505000 };

export const isDivinopolisCep = (postalCode) => {
  const value = Number(postalCode);
  return value >= DIVINOPOLIS_CEP_RANGE.min && value <= DIVINOPOLIS_CEP_RANGE.max;
};

// Fator aplicado ao subtotal/total no resumo do pedido (10% de desconto sobre price).
export const PRICE_DISCOUNT_FACTOR = 0.9;
